Efficiently manage your team by onboarding users individually or in bulk.

## User Roles

Gandalf supports different user roles to manage access and permissions.

- **User**: Standard access.
  - Can manage their own profile and contact methods.
  - Can view alerts, services, and schedules.
  - Can take actions on alerts (Ack/Close) for services they are on-call for.
- **Admin**: Full system access.
  - All **User** permissions.
  - Can create/edit/delete Users, Services, Escalation Policies, and Schedules.
  - Access to System Admin panel (Limits, Config, etc.).

## Bulk Onboarding

Admins can onboard multiple users at once using the Bulk Onboarding feature. This is ideal for initial setup or migrating teams.

### Steps

1.  Navigate to the **Users** page.
2.  Click the **Onboard Users** button.
3.  Upload a formatted `.csv` file.

### CSV Format Specification

The file **must** contain a header row.

| Column  | Required | Description           | Format                           |
| :------ | :------- | :-------------------- | :------------------------------- |
| `name`  | Yes      | User's display name   | Text                             |
| `email` | Yes      | Unique email address  | `user@example.com`               |
| `role`  | Yes      | User permission level | `user` or `manager`              |
| `phone` | Yes      | Primary phone number  | E.164 format (e.g., `+15550101`) |

**Example CSV Content:**

```csv
name,email,role,phone
Alice Smith,alice@example.com,user,+15550101
Bob Jones,bob@example.com,manager,+15550102
Charlie Day,charlie@example.com,user,+15550103
```

## Contact Methods

Contact methods determine how users receive alerts. Multi-channel notification ensures you never miss a critical page.

- **SMS**: High reliability. Good for immediate notification.
- **Voice**: Phone calls. Best for waking up on-call engineers.
- **Email**: Low urgency. Good for logs or backup.
- **Slack**: Good for team visibility during working hours.
  - _Note: Slack DM contact methods require the Slack User to link their account._
